import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import InputIcon from "@material-tailwind/react/InputIcon";
import DataTable from "react-data-table-component";


export default function CardTable({ logReferral, pending, usernameEvent, adminUsernameEvent, onChangeRowsPerPage, handlePageChange, totalRows }) {

  const columns = [
    {
      name: "#",
      width: "80px",
      selector: (row, idx) => idx + 1,
      sortable: true,
    },
    {
      name: "Admin Username",
      selector: (row) => row.admin_username,
      sortable: true,
    },
    {
      name: "Username",
      selector: (row) => row.username,
      sortable: true,
    },
    {
      name: "Old Value",
      selector: (row) => row.old_value,
      sortable: true,
    },
    {
      name: "New Value",
      selector: (row) => row.new_value,
      sortable: true,
    },
    {
      name: "Log IP",
      selector: (row) => row.ip,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => row.created_at,
      sortable: true,
    },
  ];

  return (
    <>
      <Card>
        <h5>Advanced Search</h5>
        <CardBody>
          <div className="flex gap-4">
            <InputIcon
              type="text"
              color="lightBlue"
              size="sm"
              outline={true}
              placeholder="Username"
              iconName="search"
              onChange={usernameEvent}
            />
            <InputIcon
              type="text"
              color="lightBlue"
              size="sm"
              outline={true}
              placeholder="Admin Username"
              iconName="search"
              onChange={adminUsernameEvent}
            />
          </div>
        </CardBody>
      </Card>
      <Card className="mt-12">
        <CardHeader color="blueGray" contentPosition="left">
          <h2 className="text-white text-2xl">Log Referral</h2>
        </CardHeader>
        <CardBody>
          <DataTable
            columns={columns}
            data={logReferral}
            progressPending={pending}
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={onChangeRowsPerPage}
            paginationRowsPerPageOptions={[1, 10, 50, 100, 500]}
            pagination
            paginationServer
          />
        </CardBody>
      </Card>
    </>
  );
}
